import React, { useEffect, useRef, useContext } from "react";
import {
  Avatar,
  Placeholder,
  Loader,
  Notification,
  useToaster,
  Whisper,
  Tooltip,
  Progress,
} from "rsuite";
import { Button } from "react-bootstrap";
import {
  Outlet,
  redirect,
  useLoaderData,
  useNavigate,
  NavLink,
  useParams,
} from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import Loading from "../../Loder";
// import { useTranslation } from 'react-i18next';
// import { ReferFriend } from "./ReferFriend";
import { useState } from "react";
import usePost from "../../customhooks/UsePost";
import parse from "html-react-parser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart, faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import "./JobList.css";
// import { NavLink, useParams } from "react-router-dom";
import ReferFriend from "./ReferFriend";
// import { SimilarJob } from "./SimilarJob";
// import SimilarJob from "./SimilarJob";
// import { useGetPokemonByNameQuery } from "../../app/apiConfiguration";
import { StandaloneSearchBox } from "@react-google-maps/api";

import useGetQuery from "../../customhooks/UseGetQuery";
import SubmitYourProfile from "./SubmitYourProfile/SubmitYourProfile";
import ApplyNow from "./ApplyNow";
import CreateProfileButton from "../createProfile/CreateProfileButton";
import ApplyNowModal from "./ApplyNowModal";
import UserContext from "../../app/context/UserContext";
import RecommendedJobs from "./RecomandedJobs";
import JobsList from "./JobsList";
import axios from "axios";

export default function JobDetails({ selectedJob, isLoading, Searchvalue }) {
  const [isFavourite, setIsFavourite] = useState(false);

  let loaderDetails = useLoaderData();
  // console.log(loaderDetails, "ghrtyui");
  const { t } = useTranslation();
  const {
    post: updatefavourite,
    data,
    isLoading: favouriteloading,
    error,
  } = usePost("/jobsearch/favouritejob");
  const {
    post: getOverallScore,
    data: getOverallScoreData,
    isLoading: getOverallScoreLoading,
    error: getOverallScoreError,
  } = usePost("/getOverallScore");

  const {
    post: getTotalapplicants,
    data: getTotalapplicantsData,
    isLoading: getTotalapplicantsLoading,
    error: getTotalapplicantsError,
  } = usePost("/getTotalapplicants");
  // const { data } = useGetPokemonByNameQuery("bulbasaur");
  // console.log(data);
  const inputRef = useRef();
  // console.log(selectedJob);

  // useGetQuery
  // const { data, loading, error } = useGetQuery("/api/getTheme");

  const [JobDetails, setJobDetails] = useState(null);
  const [campaignID, setcampaignID] = useState(null);
  const [passcode, setPasscode] = useState(null);
  const [jobTitle, setJobTitle] = useState(null);
  const [jobPostingSchema, setJobPostingSchema] = useState({});

  // console.log(JobDetails, "JobDetails?.job?.details?");
  let navigate = useNavigate();

  const { user, setUserDetails } = useContext(UserContext);

  useEffect(() => {
    if (user?.favoriteCampaignID?.includes(campaignID)) {
      setIsFavourite(true);
    } else {
      setIsFavourite(false);
    }
  }, [user, selectedJob, campaignID]);
  // console.log(campaignID, "fgyhjkm,");
  const toaster = useToaster();
  // console.log(loaderDetails);
  useEffect(() => {
    // console.log(data);
    if (selectedJob) {
      setJobDetails(selectedJob._source);
      setcampaignID(selectedJob?._id);
      setPasscode(selectedJob?._source?.passcode);
      // setJobTitle(selectedJob?.urlTitle?.split(' ').join('-'))
    }

    if (loaderDetails?.jobDetails) {
      setJobDetails(loaderDetails?.jobDetails);
      setcampaignID(loaderDetails?.jobDetails?._id);
      setPasscode(loaderDetails?.jobDetails?.passcode);
      // if(loaderDetails?.jobDetails?.displayName && loaderDetails?.jobDetails?.displayName == "Campaign Title"){
      setJobTitle(
        loaderDetails?.jobDetails?.urlTitle
          ?.split(" ")
          .join("-")
          .replace(/-+/g, "-")
      );
      // }else{
      //   setJobTitle(loaderDetails?.jobDetails?.job?.details?.jobTitle?.text.split(' ').join('-') )
      // }
    }
  }, [selectedJob, loaderDetails]);
  useEffect(() => {
    if (loaderDetails?.status == false) {
      window.location.replace("/jobs");
    }
  }, [loaderDetails]);
  // useEffect(() => {
  //   if (window.location.pathname.includes(`/job/${passcode}`)) {
  //     if (window.location.search == "") {
  //       window.history.replaceState({}, "", `/job/${passcode}/${jobTitle}`);
  //     } else {
  //       if (window.location.search != "") {
  //         let search = window.location.search;
  //         if (window.location.pathname != `/job/${passcode}/${jobTitle}`) {
  //           window.history.replaceState(
  //             {},
  //             "",
  //             `/job/${passcode}/${jobTitle}${search}`
  //           );
  //         }
  //       }
  //     }
  //   }
  // }, [passcode, jobTitle]);
  useEffect(() => {
    const currentPath = window.location.pathname;
    const searchParams = window.location.search;
  
    if (currentPath.includes(`/job/${passcode}`) || currentPath.includes(`/careers/job/${passcode}`)) {
      const newPath = currentPath.includes("/careers")
        ? `/careers/job/${passcode}/${jobTitle}`
        : `/job/${passcode}/${jobTitle}`;
  
      if (searchParams === "") {
        window.history.replaceState({}, "", newPath);
      } else if (currentPath !== newPath) {
        window.history.replaceState({}, "", `${newPath}${searchParams}`);
      }
    }
  }, [passcode, jobTitle]);
  

  const [cookies, setCookie] = useState("");
  const Getcookies = async () => {
    try {
      let cookieDetails = await axios.get(
        window.location.origin + "/jsv4/webapi/getcookie"
      );
      cookieDetails = cookieDetails?.data;
      // console.log("cookieDetailscookieDetails", cookieDetails);
      // console.log(user?.resumeID, "sqwdefrgthyjuki");
      if (cookieDetails["Guest_User_ResumeID"]) {
        setCookie(cookieDetails["Guest_User_ResumeID"]);
      }
    } catch (error) {
      console.log("Error in getCookies : ", error);
    }
  };
  const [updatadataMri, setupdatadataMri] = useState(false);

  useEffect(() => {
    if (JobDetails?.clientID && user?.resumeID && user?.resumeID !== "") {
      setCookie(user?.resumeID);
    } else if (JobDetails?.clientID) {
      Getcookies();
      // isMounted.current = true;
    }
  }, [user, JobDetails?.clientID, updatadataMri]);
  console.log(cookies);
  const [overall, setoverall] = useState([]);
  useEffect(() => {
    if (
      JobDetails?.clientID &&
      campaignID != "" &&
      campaignID != undefined &&
      cookies != "" &&
      cookies != undefined
    ) {
      let jobsdata = {
        campaignID: campaignID,
        companyID: loaderDetails?.companyID,
        resumeID: cookies,
        userID: user?._id,
        collection: loaderDetails?.jobDetails?.collectionName,
      };
      getOverallScore(jobsdata)
        .then((res) => {
          console.log(res, "hsssssssssssdkk");
          if (res?.status) {
            setoverall(res?.MRIscroe);
          }
        })
        .catch((error) => {
          console.error("Error while fetching favourite jobs:", error);
        });
    }
  }, [campaignID, cookies, user, updatadataMri]);
  const [totalApplicants, setTotalapplicants] = useState(0);
  useEffect(() => {
    if (campaignID != "" && campaignID != undefined) {
      let jobsdata = {
        campaignID: campaignID,
        companyID: loaderDetails?.companyID,

        collection: loaderDetails?.jobDetails?.collectionName,
      };
      getTotalapplicants(jobsdata)
        .then((res) => {
          console.log(res, "dattatts");
          if (res?.status) {
            setTotalapplicants(res.MRIscroe);
          }
        })
        .catch((error) => {
          console.error("Error while fetching favourite jobs:", error);
        });
    }
  }, [JobDetails?.clientID, user, updatadataMri]);

  // console.log(overall, "overall");

  // console.log(
  //   JobDetails?.job?.otherInformation?.industry?.classified[0]?.industryLabel,
  //   "JobDetails?.job?"
  // );
  // console.log(JobDetails, "JobDetails?.job?.details?");

  // scroll to Submit Your Profile form
  // const scrollToSubmitProfile = () => {
  //   console.log("hiii");
  // };
  const [openModal, setOpenModal] = useState(false);

  const handlefavourite = () => {
    if (user) {
      if (user?._id !== "") {
        let body = {
          userID: user?._id,
          campaignID: campaignID,
          operationType: "",
        };
        if (isFavourite) {
          body.operationType = "unFavourite";
        } else {
          body.operationType = "favourite";
        }
        // console.log(body);
        updatefavourite(body)
          .then((res) => {
            if (res?.data?.status) {
              if (isFavourite) {
                setIsFavourite(false);
                toaster.push(
                  <Notification
                    type={"success"}
                    /* header="Success" */ header={t("success", {
                      defaultValue: "Success",
                    })}
                    closable
                  >
                    <span>
                      {/* Successfully Removed As Favorite */}
                      {t("successfullyRemovedasFavorite", {
                        defaultValue: "Successfully Removed As Favorite",
                      })}
                    </span>
                    {/* <Trans
                      i18nKey="successfullyRemovedasFavorite"
                      defaults="Successfully Removed As Favorite"
                    /> */}
                  </Notification>,
                  { placement: "topEnd" }
                );
              } else {
                toaster.push(
                  <Notification
                    type={"success"}
                    /* header="Success" */ header={t("success", {
                      defaultValue: "Success",
                    })}
                    closable
                  >
                    <span>
                      {/* Successfully Saved As Favorite */}
                      {t("successfullySavedasFavorite", {
                        defaultValue: "Successfully Saved As Favorite",
                      })}
                    </span>
                    {/* <Trans
                      i18nKey="successfullySavedasFavorite"
                      defaults="Successfully Saved As Favorite"
                    /> */}
                  </Notification>,
                  { placement: "topEnd" }
                );
                setIsFavourite(true);
              }
            } else {
              toaster.push(
                <Notification
                  type={"error"}
                  /* header="Error" */ header={t("error", {
                    defaultValue: "Error",
                  })}
                  closable
                >
                  <span>
                    {/* Something went wrong please try again */}
                    {t("somethingWentWrongPleaseTryAgainLater", {
                      defaultValue:
                        "Something went wrong.Please try again later",
                    })}
                  </span>
                  {/* <Trans
                    i18nKey="successfullySavedasFavorite"
                    defaults="Successfully Saved As Favorite"
                  /> */}
                </Notification>,
                { placement: "topEnd" }
              );
            }
          })
          .catch((error) => {
            console.error("Error while fetching jobs:", error);
          });
      }
    } else {
      setOpenModal(true);
    }
  };
  const [campiganpageicon, setcampiganpageicon] = useState(false);
  useEffect(() => {
    if (typeof window !== "undefined") {
      if (window.location.pathname == "/jobs") {
        setcampiganpageicon(true);
      }
    }
  }, [JobDetails]);

  const {
    post: Recomandedjobs,
    data: recomdeddata,
    isLoading: RecomandedjobsLoading,
  } = usePost("/getRecommendedJobs");
  const { post: getPagevisits } = usePost("/pagevisit");

  const [recomadedJobs, setRecomandedJobs] = useState([]);
  useEffect(() => {
    if (JobDetails?.clientID && campaignID && loaderDetails?.companyID) {
      Recomandedjobs({
        clientID: JobDetails?.clientID,
        campaignID: campaignID,
        companyID: loaderDetails?.companyID,
      })
        .then((res) => {
          // console.log(res?.result?.data);
          if (res?.result?.data?.status) {
            setRecomandedJobs(res?.result?.data?.result);
          }
        })
        .catch((error) => {
          console.error("Error while fetching Recomadedjobs:", error);
        });
    }
  }, [JobDetails?.clientID]);
  const previousURL = React.useRef(null);

  const getpagevisitsdata = () => {
    if (
      loaderDetails?.companyID &&
      loaderDetails?.companyName &&
      JobDetails?.title
    ) {
      let path = window.location.href;
      let title;
      let titleExists = true;
      let page = "";
      let subPage = "";
      let Jobtitle;
      if (JobDetails?.displayName) {
        if (JobDetails?.displayName == "Campaign Title") {
          Jobtitle = JobDetails?.title ?? "unkown";
        } else {
          Jobtitle = JobDetails?.job?.details?.jobTitle?.text ?? "unkown";
        }
      } else {
        Jobtitle = JobDetails?.title ?? "unkown";
      }
      if (path.includes("jobdetails")) {
        title = `${Jobtitle} | Job Details | ${loaderDetails?.companyName}`;
        page = "Jobdetails";
        subPage = "Jobdetails";
      } else if (path.includes("jobs")) {
        title = `${Jobtitle} | Jobs | ${loaderDetails?.companyName}`;
        page = "Jobs";
        subPage = "Jobs";
      } else if (path.includes("job")) {
        title = `${Jobtitle} | Job Details | ${loaderDetails?.companyName}`;
        page = "Jobdetails";
        subPage = "Jobdetails";
      } else {
        titleExists = false;
        title = loaderDetails?.companyName;
      }
      let previousTableBody = JSON.parse(JSON.stringify(document.title));

      // if (
      //   titleExists &&
      //   title &&
      //   previousURL.current != window.location.href &&
      //   JSON.stringify(previousTableBody) !== JSON.stringify(title)
      // ) {
      //   getPagevisits({
      //     url: window.location.href,
      //     title: title,
      //     page: page,
      //     subPage: subPage,
      //     userID: user?._id ?? "",
      //     companyID: loaderDetails?.companyID,
      //     campaignID: campaignID,
      //   })
      //     .then((res) => {
      //       console.log(res);
      //     })
      //     .catch((error) => {
      //       console.log("Error while fetching pagevisits:", error?.stack);
      //     });
      // }
      previousURL.current = window.location.href;
      document.title = title;
    }
  };
  useEffect(() => {
    if (campaignID && campaignID !== null) {
      getpagevisitsdata();
    }
  }, [campaignID]);
  // console.log(campaignID, "ghjkbrjgtnkymuui");
  const [Loactionreslut, setLocationreslut] = useState("NA");

  useEffect(() => {
    let objectWithNonEmptyCity = null;
    for (let i = 0; i < JobDetails?.job?.details?.locations.length; i++) {
      const location = JobDetails?.job?.details?.locations[i];
      if (location.city && location.city.trim() !== "") {
        objectWithNonEmptyCity = location;
        break;
      }
    }
    if (objectWithNonEmptyCity !== null) {
      setLocationreslut(objectWithNonEmptyCity);
    } else {
      setLocationreslut("NA");
    }
  }, [Loactionreslut, campaignID, JobDetails]);
  // console.log(JobDetails);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [loaderDetails]);

  useEffect(()=>{
    if(JobDetails && Object.keys(JobDetails)?.length > 0){
      const postingJobSchema = {
        "@context": "https://schema.org",
        "@type": "JobPosting",
        "title": JobDetails?.displayName && JobDetails?.displayName === "Campaign Title" ? JobDetails?.title ?? "Unknown" : JobDetails?.job.details?.jobTitle?.text ?? "Unkown",
        "description": JobDetails?.job?.details?.jobDescription?.text ?? "",
        "identifier": {
          "@type": "PropertyValue",
          "name": "TRC Talent Solutions",
          "value": JobDetails?.passcode ?? ""
        },
        "datePosted": JobDetails?.createdAt && new Date(JobDetails?.createdAt).toISOString().slice(0, 10),
        "validThrough": "",
        "employmentType": JobDetails?.job?.details?.jobTitle?.jobType ? JobDetails?.job?.details?.jobTitle?.jobType : "",
        "hiringOrganization": {
          "@type": "Organization",
          "name": "TRC Talent Solutions",
          "sameAs": "https://trctalent.com/",
          "logo": "data:image/png;base64,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"
        },
        "jobLocation": {
          "@type": "Place",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": JobDetails?.job?.details?.locations && JobDetails?.job?.details?.locations?.length > 0 ? JobDetails?.job?.details?.locations[0]?.city : "",
            "addressRegion": JobDetails?.job?.details?.locations && JobDetails?.job?.details?.locations?.length > 0 ? JobDetails?.job?.details?.locations[0]?.state : "",
            "postalCode": JobDetails?.job?.details?.locations && JobDetails?.job?.details?.locations?.length > 0 ? JobDetails?.job?.details?.locations[0]?.postalCode : "",
            "addressCountry": JobDetails?.job?.details?.locations && JobDetails?.job?.details?.locations?.length > 0 ? JobDetails?.job?.details?.locations[0]?.countryCode : ""
          }
        },
        "baseSalary": {
          "@type": "MonetaryAmount",
          "currency": JobDetails?.job?.details?.offeredSalary?.currency ? JobDetails?.job?.details?.offeredSalary?.currency : "",
          "value": {
            "@type": "QuantitativeValue",
            "minValue": JobDetails?.job?.details?.offeredSalary?.minvalue ? JobDetails?.job?.details?.offeredSalary?.minvalue : "",
            "maxValue": JobDetails?.job?.details?.offeredSalary?.maxvalue ? JobDetails?.job?.details?.offeredSalary?.maxvalue : "",
            "unitText": JobDetails?.job?.details?.offeredSalary?.period ? JobDetails?.job?.details?.offeredSalary?.period : ""
          }
        },
        "jobLocationType": "",
        "applicantLocationRequirements": {
          "@type": "Country",
          "name": JobDetails?.job?.details?.locations && JobDetails?.job?.details?.locations?.length > 0 ? JobDetails?.job?.details?.locations[0]?.countryCode : ""
        },
        "responsibilities": "",
        "skills": "",
        "industry": JobDetails?.job?.otherInformation?.industry?.classified && JobDetails?.job?.otherInformation?.industry?.classified.length > 0 ? JobDetails?.job?.otherInformation?.industry?.classified[0]?.industryLabel : "",
        "qualifications": "",
        "experienceRequirements": ""
      } 

      setJobPostingSchema(postingJobSchema);
    }   
  },[JobDetails])
console.log(jobPostingSchema,"Fggggggggggggggg")
  // console.log(campaignID, selectedJob,loaderDetails,isLoading,"campaignID");
  return (
    <>
      {selectedJob?._id || loaderDetails?.jobDetails?._id || !isLoading ? (
        <>
          {isLoading ||
          campaignID == "" ||
          campaignID == null ||
          campaignID == undefined ? (
            <>
              <div className="card w-100">
                <div className="card-body">
                  <Placeholder.Grid rows={6} columns={2} active />
                </div>
              </div>
            </>
          ) : (
            <div className="row" key={JobDetails?._id}>
              <div
                className={`${
                  JobDetails?.clientID
                    ? "col-xl-9 col-lg-9  col-sm-12"
                    : "col-12"
                }`}
              >
                <div className="row">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body ">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                            <h3 className="text-capitalize titleColor">
                              {JobDetails?.displayName ? (
                                <>
                                  {JobDetails?.displayName ==
                                  "Campaign Title" ? (
                                    <b>{JobDetails?.title ?? "unkown"}</b>
                                  ) : (
                                    <>
                                      {JobDetails?.job.details?.jobTitle
                                        ?.text ?? "unkown"}
                                    </>
                                  )}
                                </>
                              ) : (
                                <b>{JobDetails?.title ?? "unkown"}</b>
                              )}
                            </h3>

                            {/* {typeof window !== "undefined" && ( */}
                            {/* <> */}
                            {/* {!window.location.href.includes("/jobdetails") && ( */}
                            {campiganpageicon && (
                              <Whisper
                                followCursor
                                placement={"bottom"}
                                speaker={
                                  <Tooltip>
                                    {/* Redirect to Job Details Page */}{" "}
                                    <Trans
                                      i18nKey="redirectToJobDetailsPage"
                                      defaults="Redirect to Job Details Page"
                                    />
                                  </Tooltip>
                                }
                              >
                                <NavLink
                                  target="_blank"
                                  className="ps-2"
                                  to={`/job/${passcode}`}
                                  // to={`/jobdetails/${campaignID}`}
                                >
                                  <FontAwesomeIcon icon={faExternalLinkAlt} />
                                </NavLink>
                              </Whisper>
                            )}
                          </div>
                          {!campiganpageicon && (
                            <div>
                              <div>Posted : {totalApplicants?.posted}</div>
                              <div>
                                Total applicants :{" "}
                                {totalApplicants?.Totalapplicants}
                              </div>
                            </div>
                          )}
                          {/* )}
                    </>
                  )} */}
                        </div>
                        <ul className="list-unstyled">
                          <li className="text-capitalize">
                            {Loactionreslut?.cityCanonical ? (
                              <>
                                {Loactionreslut?.cityCanonical},{" "}
                                {Loactionreslut?.stateCanonical
                                  ? Loactionreslut?.stateCanonical
                                  : Loactionreslut?.state}
                              </>
                            ) : Loactionreslut?.city ? (
                              <>
                                {Loactionreslut?.city},{" "}
                                {Loactionreslut?.stateCanonical
                                  ? Loactionreslut?.stateCanonical
                                  : Loactionreslut?.state}{" "}
                              </>
                            ) : (
                              "NA"
                            )}
                            {/* {JobDetails?.job?.details?.locations?.[0]?.text ?? "NA"} */}
                          </li>
                          <li className="text-capitalize">
                            {" "}
                            {JobDetails?.job?.details?.jobTitle?.jobType
                              ? JobDetails?.job?.details?.jobTitle?.jobType
                              : "NA"}
                          </li>

                          {JobDetails?.customData?.[
                            "6112806bc9147f673d28c6eb"
                          ]?.["64abb309db7899f5908c77aa"]?.value && (
                            <li className="text-capitalize">
                              {
                                JobDetails?.customData?.[
                                  "6112806bc9147f673d28c6eb"
                                ]?.["64abb309db7899f5908c77aa"]?.value
                              }
                            </li>
                          )}

                          {/* <li className="text-capitalize">Job Category</li> */}
                          {/* <li>
                        {JobDetails?.job?.otherInformation?.industry
                          ?.classified[0]?.industryLabel
                          ? JobDetails?.job?.otherInformation?.industry
                              ?.classified[0]?.industryLabel
                          : "NA"}
                      </li> */}

                          <li>
                            {" "}
                            <span>
                              $
                              <span className="pe-1">
                                {JobDetails?.job?.details?.offeredSalary
                                  ?.minvalue ==
                                JobDetails?.job?.details?.offeredSalary
                                  ?.maxvalue ? (
                                  <>
                                    {
                                      JobDetails?.job?.details?.offeredSalary
                                        ?.minvalue
                                    }
                                  </>
                                ) : (
                                  <>
                                    {JobDetails?.job?.details?.offeredSalary
                                      ?.minvalue
                                      ? JobDetails?.job?.details?.offeredSalary
                                          ?.minvalue
                                      : "0"}
                                    -
                                    {JobDetails?.job?.details?.offeredSalary
                                      ?.maxvalue
                                      ? JobDetails?.job?.details?.offeredSalary
                                          ?.maxvalue
                                      : "0"}
                                  </>
                                )}
                                {/* {JobDetails?.job?.details?.offeredSalary?.minvalue
                          ? JobDetails?.job?.details?.offeredSalary?.minvalue
                          : "0"}
                        -
                        {JobDetails?.job?.details?.offeredSalary?.maxvalue
                          ? JobDetails?.job?.details?.offeredSalary?.maxvalue
                          : "0"} */}
                              </span>
                              <span>
                                {JobDetails?.job?.details?.offeredSalary?.period
                                  ? JobDetails?.job?.details?.offeredSalary
                                      ?.period
                                  : "NA"}
                              </span>
                            </span>
                          </li>
                        </ul>

                        <div className="d-flex justify-content-between">
                          <div className="d-flex align-items-center">
                            {/* <Button
                  onClick={scrollToSubmitProfile}
                  className="btn-primary rounded-pill">
                  Apply Now
                </Button> */}

                            {/* // apply now */}
                            <ApplyNow
                              campaignID={campaignID}
                              setupdatadataMri={setupdatadataMri}
                            />

                            <div
                              className="ps-2"
                              role="button"
                              onClick={() => {
                                handlefavourite();
                              }}
                            >
                              <Avatar
                                circle
                                className={`border ${
                                  isFavourite
                                    ? "border-primary"
                                    : "text-secondary"
                                } bg-white`}
                              >
                                {favouriteloading ? (
                                  <Loader />
                                ) : (
                                  <FontAwesomeIcon
                                    icon={faHeart}
                                    className={
                                      isFavourite
                                        ? "text-primary"
                                        : "text-black-50"
                                    }
                                  />
                                )}
                              </Avatar>
                            </div>
                          </div>
                          {/* // refer friend  */}
                          <div>
                            <ReferFriend campaignID={campaignID} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="bg-white rounded p-3 jobdetailscard">
                      <h3>
                        {" "}
                        <Trans i18nKey="jobDetails" defaults="Job Details" />
                      </h3>
                      <div className="hr-navy"></div>
                      {/* <h6>
                    <b> Job Description </b>
                  </h6> */}
                      <div className="Jobdetailstext">
                        {JobDetails?.job?.details?.jobDescription?.text &&
                          parse(JobDetails?.job?.details?.jobDescription?.text)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-lg-3  col-sm-12">
                {JobDetails?.clientID && (
                  <>
                    {overall?.length > 0 ? (
                      <div className="card mb-3">
                        <div className="card-body">
                          <div className="text-center">
                            <h6>Overall Score</h6>
                            <div className="d-flex justify-content-center align-items-center">
                              <Progress.Circle
                                percent={Math.round(
                                  overall?.[0]?.MRI?.experience?.matchScore ?? 0
                                )}
                                width={70}
                              />
                            </div>
                          </div>

                          {/* </div> */}
                        </div>
                      </div>
                    ) : getOverallScoreLoading ? (
                      <Placeholder.Grid rows={3} columns={2} active />
                    ) : (
                      ""
                    )}
                    {RecomandedjobsLoading ? (
                      <>
                        <div className="card m-2">
                          <div className="card-body">
                            <Placeholder.Grid rows={3} columns={2} active />
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        {recomadedJobs.length > 0 && (
                          <>
                            <h5 className="mx-2 mt-1">
                              {/* Recommended Jobs */}
                              <Trans
                                i18nKey="recommendedJobs"
                                defaults="Recommended Jobs"
                              />
                            </h5>

                            {recomadedJobs?.map((x) => {
                              return (
                                <a
                                  key={x?._id}
                                  href={`/job/${x?._source?.passcode}`}
                                  className="text-decoration-none"
                                >
                                  <JobsList
                                    data={x}
                                    isLoading={RecomandedjobsLoading}
                                    type="jobdetails"
                                  />
                                </a>
                                // <RecommendedJobs
                                //   key={x?._id}
                                //   Job={x}
                                //   Loading={RecomandedjobsLoading}
                                //   setJobDetails={setJobDetails}
                                //   setcampaignID={setcampaignID}
                                // />
                              );
                            })}
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
              <ApplyNowModal
                openModal={openModal}
                setOpenModal={setOpenModal}
                from={"favourite"}
              />
            </div>
          )}
        </>
      ) : (
        <div className="d-flex justify-content-center">
          <img
            src="https://recruiterqa.maprecruit.com/assets/images/campaignClosed-min.png"
            width={800}
          />
        </div>
      )}
      <script type="application/ld+json">
        {JSON.stringify(jobPostingSchema)}
      </script>
    </>
  );
}
